import { Outlet, createFileRoute } from '@tanstack/react-router';

import { AdminLayout } from '@/components/admin-layout';

export const Route = createFileRoute('/_authenticated/admin')({
  component: () => (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  ),
});
